import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

/**
 * A custom element that allows the user to clean a search input.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} searchPageInput - The search input element.
 * @extends {Component<Refs>}
 */
class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  /**
   * Handles the click event on the clear button and submits an empty search.
   * This clears the search input and resubmits the form if the page is not
   * already in an empty state.
   */
  
  /**
   * 
       
    handleClearClick() {
    this.#submitEmptySearch();
  }
   */
  



  handleClearClick() {
  this.refs.searchPageInput.value = '';
  this.refs.searchPageInput.focus();
}


  /**
   * Handles the keydown event on the search input and resets the search when
   * empty and Escape is pressed.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();

    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
    }
  }, 100);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;

    searchInput.focus();
    searchInput.value = '';

    if (this.#isEmptyState()) return;

    searchInput.form?.submit();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get('q') ?? '';

    return queryParam.trim() === '';
  };
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}

/* ── Dog Breed Concept Search — Fuzzy Dropdown ── */

(function () {
  const BREEDS = ["French Bulldog","Labrador Retriever","Golden Retriever","German Shepherd Dog","Dachshund","Poodle","Beagle","Rottweiler","German Shorthaired Pointer","Bulldog","Cane Corso","Cavalier King Charles Spaniel","Yorkshire Terrier","Australian Shepherd","Doberman Pinscher","Pembroke Welsh Corgi","Miniature Schnauzer","Boxer","Pomeranian","Bernese Mountain Dog","Shih Tzu","Great Dane","Boston Terrier","Chihuahua","Havanese","Border Collie","English Springer Spaniel","Miniature American Shepherd","Shetland Sheepdog","Siberian Husky","Brittany","Belgian Malinois","Cocker Spaniel","Basset Hound","English Cocker Spaniel","Vizsla","Maltese","Pug","Collie","Mastiff","Rhodesian Ridgeback","Papillon","Portuguese Water Dog","Shiba Inu","West Highland White Terrier","Newfoundland","Australian Cattle Dog","Whippet","Bichon Frise","Dalmatian","Wirehaired Pointing Griffon","Giant Schnauzer","Italian Greyhound","Weimaraner","Samoyed","Chesapeake Bay Retriever","Scottish Terrier","German Wirehaired Pointer","Bloodhound","Russell Terrier","Staffordshire Bull Terrier","Akita","Saint Bernard","Boykin Spaniel","Cardigan Welsh Corgi","Great Pyrenees","Miniature Pinscher","Cairn Terrier","Nova Scotia Duck Tolling Retriever","Airedale Terrier","Greater Swiss Mountain Dog","Chinese Crested","Irish Setter","Biewer Terrier","Irish Wolfhound","Soft Coated Wheaten Terrier","Lagotto Romagnolo","Bullmastiff","Coton de Tulear","Chinese Shar-Pei","Alaskan Malamute","Brussels Griffon","Lhasa Apso","Rat Terrier","Keeshond","Bull Terrier","Old English Sheepdog","Anatolian Shepherd Dog","English Setter","Pekingese","Border Terrier","Basenji","Standard Schnauzer","Chow Chow","Dogue de Bordeaux","Leonberger","American Staffordshire Terrier","Flat-Coated Retriever","Borzoi","Bouvier des Flandres","Dogo Argentino","Beauceron","Japanese Chin","Gordon Setter","Miniature Bull Terrier","Toy Fox Terrier","Wire Fox Terrier","American Hairless Terrier","Norwich Terrier","Schipperke","Pointer","Boerboel","Spinone Italiano","Welsh Terrier","Belgian Tervuren","Silky Terrier","Afghan Hound","Tibetan Terrier","Neapolitan Mastiff","Belgian Sheepdog","Parson Russell Terrier","Tibetan Spaniel","Xoloitzcuintli","American Eskimo Dog","Mudi","Norfolk Terrier","Finnish Lapphund","Norwegian Elkhound","Barbet","Wirehaired Vizsla","Manchester Terrier","Bluetick Coonhound","Clumber Spaniel","English Toy Spaniel","Saluki","Bracco Italiano","Black and Tan Coonhound","Icelandic Sheepdog","German Pinscher","Bearded Collie","Welsh Springer Spaniel","Tibetan Mastiff","Treeing Walker Coonhound","Smooth Fox Terrier","Russian Toy","Redbone Coonhound","Bedlington Terrier","Field Spaniel","Irish Terrier","Australian Terrier","Greyhound","Swedish Vallhund","Affenpinscher","Black Russian Terrier","Kerry Blue Terrier","Scottish Deerhound","Lakeland Terrier","Nederlandse Kooikerhondje","Löwchen","Pumi","Petit Basset Griffon Vendéen","Irish Red and White Setter","Sealyham Terrier","Portuguese Podengo Pequeno","Glen of Imaal Terrier","Berger Picard","Spanish Water Dog","Curly-Coated Retriever","Irish Water Spaniel","Danish-Swedish Farmdog","Plott Hound","Briard","Norwegian Buhund","Ibizan Hound","Sussex Spaniel","American Water Spaniel","Puli","Entlebucher Mountain Dog","Kuvasz","Pharaoh Hound","Skye Terrier","American English Coonhound","Bergamasco Sheepdog","Cirneco dell'Etna","Komondor","Dandie Dinmont Terrier","English Foxhound","American Foxhound","Otterhound","Lancashire Heeler","Pyrenean Shepherd","Polish Lowland Sheepdog","Canaan Dog","Finnish Spitz","Azawakh","Belgian Laekenois","Cesky Terrier","Chinook","Harrier","Grand Basset Griffon Vendéen","Sloughi","Norwegian Lundehund","Alaskan Klee Kai","American Bulldog","American Leopard Hound","Appenzeller Sennenhund","Australian Kelpie","Australian Stumpy Tail Cattle Dog","Basset Fauve de Bretagne","Bavarian Mountain Scent Hound","Braque du Bourbonnais","Braque Français Pyrenean","Broholmer","Carolina Dog","Catahoula Leopard Dog","Caucasian Shepherd Dog","Central Asian Shepherd Dog","Croatian Sheepdog","Czechoslovakian Vlcak","Deutscher Wachtelhund","Drentsche Patrijshond","Drever","Dutch Shepherd","Estrela Mountain Dog","Eurasier","German Longhaired Pointer","German Spitz","Hamiltonstovare","Hanoverian Scenthound","Hokkaido","Hovawart","Jämthund","Japanese Akitainu","Japanese Spitz","Japanese Terrier","Kai Ken","Karelian Bear Dog","Kishu Ken","Korean Jindo Dog","Kromfohrländer","Lapponian Herder","Maremma Sheepdog","Mountain Cur","Peruvian Inca Orchid","Porcelaine","Portuguese Pointer","Portuguese Sheepdog","Pudelpointer","Pyrenean Mastiff","Rafeiro do Alentejo","Romanian Mioritic Shepherd Dog","Russian Tsvetnaya Bolonka","Schapendoes","Segugio Italiano","Shikoku","Slovakian Wirehaired Pointer","Slovensky Cuvac","Slovensky Kopov","Small Munsterlander Pointer","Spanish Mastiff","Stabyhoun","Swedish Lapphund","Taiwanese Dog","Teddy Roosevelt Terrier","Thai Bangkaew Dog","Thai Ridgeback","Tornjak","Tosa","Transylvanian Hound","Treeing Tennessee Brindle"];

  function levenshtein(a, b) {
    const m = a.length, n = b.length;
    const dp = Array.from({length: m + 1}, (_, i) => Array.from({length: n + 1}, (_, j) => i === 0 ? j : j === 0 ? i : 0));
    for (let i = 1; i <= m; i++)
      for (let j = 1; j <= n; j++)
        dp[i][j] = a[i-1] === b[j-1] ? dp[i-1][j-1] : 1 + Math.min(dp[i-1][j], dp[i][j-1], dp[i-1][j-1]);
    return dp[m][n];
  }

  function fuzzyMatchBreeds(query) {
    const q = query.toLowerCase();
    const maxDist = q.length <= 4 ? 2 : 3;
    const results = [];
    for (const breed of BREEDS) {
      const b = breed.toLowerCase();
      if (b === q) { results.push({breed, score: 0}); continue; }
      if (b.startsWith(q) || b.includes(q)) { results.push({breed, score: 1}); continue; }
      // Check each word in breed name
      const words = b.split(' ');
      let wordMatch = false;
      for (const word of words) {
        if (word.startsWith(q) || levenshtein(q, word.slice(0, q.length)) <= (q.length <= 4 ? 1 : 2)) {
          wordMatch = true; break;
        }
      }
      if (wordMatch) { results.push({breed, score: 2}); continue; }
      const dist = levenshtein(q, b.slice(0, Math.min(b.length, q.length + 3)));
      if (dist <= maxDist) results.push({breed, score: 3 + dist});
    }
    return results.sort((a, b) => a.score - b.score).slice(0, 3).map(r => r.breed);
  }

  function fuzzyRankProducts(query, products) {
    const q = query.toLowerCase();
    return products.map(p => {
      const t = p.title.toLowerCase();
      let score = 99;
      if (t === q) score = 0;
      else if (t.startsWith(q)) score = 1;
      else if (t.includes(q)) score = 2;
      else score = levenshtein(q, t.slice(0, Math.min(t.length, q.length + 3)));
      return {...p, score};
    }).sort((a, b) => a.score - b.score).slice(0, 4);
  }

  async function fetchPredictive(query) {
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
    const res = await fetch(url);
    const data = await res.json();
    return data.resources?.results?.products || [];
  }

  function extractConceptTags(products, topBreed) {
    const breedLower = topBreed ? topBreed.toLowerCase() : '';
    const tagCounts = {};
    for (const p of products) {
      for (const tag of (p.tags || [])) {
        const t = tag.trim();
        if (t.toLowerCase() === breedLower) continue;
        if (t.toLowerCase().includes(breedLower) && breedLower.length > 3) continue;
        tagCounts[t] = (tagCounts[t] || 0) + 1;
      }
    }
    return Object.entries(tagCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([tag]) => tag);
  }

function positionDropdown(dropdown, input) {
  const rect = input.getBoundingClientRect();
  const isMobile = window.innerWidth <= 749;
  if (isMobile) {
    dropdown.style.top = (rect.bottom + 6) + 'px';
    dropdown.style.left = '';
    dropdown.style.width = '';
  } else {
    dropdown.style.top = (rect.bottom + 6) + 'px';
    dropdown.style.left = rect.left + 'px';
    dropdown.style.width = Math.max(rect.width, 640) + 'px';
  }
}
let productCache = [];

async function buildProductCache() {
  const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
  const seen = new Set();
  for (const l of letters) {
    const products = await fetchPredictive(l);
    for (const p of products) {
      if (!seen.has(p.id)) {
        seen.add(p.id);
        productCache.push(p);
      }
    }
  }
}


  function initDogBreedSearch() {
    const input = document.getElementById('SearchPageInput--' + (document.querySelector('search-page-input-component')?.getAttribute('id') || ''))
      || document.querySelector('input[name="q"].search-page-input');
    if (!input) return;
    buildProductCache();

    // Create dropdown
    const dropdown = document.createElement('div');
    dropdown.className = 'dbs-dropdown';
    dropdown.innerHTML = `
      <div class="dbs-cols">
        <div class="dbs-col" id="dbs-suggestions-col">
          <div class="dbs-col-header">Suggestions</div>
          <div class="dbs-chips" id="dbs-breed-chips"></div>
          <div id="dbs-concept-section" style="display:none">
            <div class="dbs-concept-label">Concepts</div>
            <div class="dbs-chips" id="dbs-concept-chips"></div>
          </div>
        </div>
        <div class="dbs-col" id="dbs-products-col">
          <div class="dbs-col-header">Products</div>
          <div class="dbs-products" id="dbs-products-list"></div>
        </div>
      </div>`;
    document.body.appendChild(dropdown);

    const breedChips = dropdown.querySelector('#dbs-breed-chips');
    const conceptSection = dropdown.querySelector('#dbs-concept-section');
    const conceptChips = dropdown.querySelector('#dbs-concept-chips');
    const productsList = dropdown.querySelector('#dbs-products-list');

    function closeDropdown() {
      dropdown.classList.remove('is-open');
    }

    function openDropdown() {
      positionDropdown(dropdown, input);
      dropdown.classList.add('is-open');
    }

    let debounceTimer;
input.addEventListener('input', () => {
  clearTimeout(debounceTimer);
  const q = input.value.trim();
  if (q.length < 2) { closeDropdown(); return; }
  debounceTimer = setTimeout(() => runSearch(q, true), 200);
});


    async function runSearch(q) {
      // Breeds
      const breeds = fuzzyMatchBreeds(q);
      breedChips.innerHTML = breeds.length
        ? breeds.map(b => `<span class="dbs-chip" data-breed="${b}">${b}</span>`).join('')
        : '<span class="dbs-empty">No breeds found</span>';

      // Products + concept tags
      const rawProducts = productCache.length ? productCache : await fetchPredictive(q);
const ranked = fuzzyRankProducts(q, rawProducts);


      productsList.innerHTML = ranked.length
        ? ranked.map(p => `
            <a class="dbs-product" href="${p.url}">
              ${p.featured_image?.url ? `<img class="dbs-product-img" src="${p.featured_image.url}&width=96" alt="${p.title}">` : '<div class="dbs-product-img"></div>'}
              <span class="dbs-product-title">${p.title}</span>
            </a>`).join('')
        : '<span class="dbs-empty">No products found</span>';

      // Concept tags from top breed's products
      const topBreed = breeds[0];
      if (topBreed) {
        const breedProducts = await fetchPredictive(topBreed);
        const concepts = extractConceptTags(breedProducts, topBreed);
        if (concepts.length) {
          conceptChips.innerHTML = concepts.map(t => `<span class="dbs-chip dbs-chip--concept" data-tag="${t}">${t}</span>`).join('');
          conceptSection.style.display = 'block';
        } else {
          conceptSection.style.display = 'none';
        }
      } else {
        conceptSection.style.display = 'none';
      }

      openDropdown();
    }

// Chip clicks
dropdown.addEventListener('click', e => {
  const chip = e.target.closest('.dbs-chip');
  if (!chip) return;

  if (chip.dataset.breed) {
    input.value = chip.dataset.breed;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  } else if (chip.dataset.tag) {
    const current = input.value.trim();
    const tag = chip.dataset.tag;
    input.value = current ? `${current} ${tag}` : tag;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }
});


    // Keyboard nav
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeDropdown();
    });

    // Click outside
    document.addEventListener('click', e => {
      if (!dropdown.contains(e.target) && e.target !== input) closeDropdown();
    });

    // Reposition on scroll/resize
    window.addEventListener('scroll', () => { if (dropdown.classList.contains('is-open')) positionDropdown(dropdown, input); }, {passive: true});
    window.addEventListener('resize', () => { if (dropdown.classList.contains('is-open')) positionDropdown(dropdown, input); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDogBreedSearch);
  } else {
    initDogBreedSearch();
  }
})();
